<script setup>
import {inject} from "vue";
//import functions

//import components
import {Icon} from "@iconify/vue";
import {
  Dialog,
  InputText,
  FloatLabel,
} from "primevue";
//import stores
//import composables
import {useBreakpoint} from "@/composables/useBreakpoint.js";

//stores

//loading flags

//other composables
const {isXL} = useBreakpoint();

//emits

//props
const props = defineProps({
  item: {
    type: Object,
    required: true
  }
})

//injects
const visible = inject('isShowItemLogModal')

//component variables

//component functions

//hooks

</script>

<template>
  <Dialog v-model:visible="visible"
          :class="['max-w-3xl !border-0 !rounded-md !bg-[#0e1726]', isXL ? '' : 'w-full']"
          :position="isXL ? 'center' : 'bottom'"
          closable dismissable-mask draggable modal
          content-class="min-w-full min-h-full flex flex-col gap-4 overflow-hidden h-full w-full max-w-[calc(100vw-20px)] max-h-[calc(100vh-100px)]">
    <template #header>
      <div class="text-base py-3">
        ID : {{ item.orderUUID ? item.orderUUID : item.orderID }}
      </div>
    </template>
    <template #closebutton="{closeCallback}">
      <div class="h-full w-[1px] bg-slate-700"></div>
      <button
          type="button"
          class="text-white-dark outline-none hover:text-red-500"
          @click="closeCallback"
      >
        <Icon icon="pajamas:close-xs"/>
      </button>
    </template>
    <div class="flex-1 flex flex-col gap-4 overflow-y-auto pt-4 pb-1 text-xs 2xl:text-sm min-w-80 max-w-full">
      <div class="grid grid-cols-2 gap-3 justify-between">
        <div class="flex flex-col text-sm">
          <FloatLabel variant="on">
            <InputText id="hotOrderTitle" :value="item.orderUUID ? item.orderUUID : item.orderID" autocomplete="off" readonly disabled
                       class="!bg-transparent w-full rounded-md h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700 p-filled"/>
            <label for="hotOrderTitle" class="!bg-slate-900">Order ID</label>
          </FloatLabel>
        </div>
        <div class="flex flex-col text-sm">
          <FloatLabel variant="on">
            <InputText id="takerName" :value="item.state" autocomplete="off" readonly disabled
                       class="!bg-transparent w-full rounded-md h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700 p-filled"/>
            <label for="takerName" class="!bg-slate-900">State</label>
          </FloatLabel>
        </div>
      </div>
      <div class="flex-1 flex flex-col text-sm overflow-hidden gap-0.5">
        <span class="text-[#a1a1aa]">Logs:</span>
        <div class="p-2 rounded-md border border-slate-700 overflow-y-auto">
          <p v-if="item.logs" class="pr-2 break-all text-slate-400" v-html="item.logs?.replace(/\n/g, '<br>')"></p>
          <p v-else class="py-4 text-slate-400 text-center">No Logs</p>
        </div>
      </div>
    </div>
  </Dialog>
</template>
<style></style>